import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-button-carousel" }
const _hoisted_2 = { class: "textButtonCarousel-title" }
const _hoisted_3 = { class: "textButtonCarousel-container" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "textButtonCarousel-navigation" }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["width", "height", "viewBox"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.1722 12L8.22217 7.04999L9.63617 5.63599L16.0002 12L9.63617 18.364L8.22217 16.95L13.1722 12Z",
  fill: "#242C33"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["width", "height", "viewBox"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.1722 12L8.22217 7.04999L9.63617 5.63599L16.0002 12L9.63617 18.364L8.22217 16.95L13.1722 12Z",
  fill: "#242C33"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ul", {
        ref: "carouselScrollArea",
        id: _ctx.carouselScrollAreaId,
        class: "textButtonCarousel-scrollArea"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textButtonList, (txtButton) => {
          return (_openBlock(), _createElementBlock("li", {
            key: txtButton.link
          }, [
            _createElementVNode("a", {
              href: txtButton.link
            }, _toDisplayString(txtButton.text), 9, _hoisted_5)
          ]))
        }), 128))
      ], 8, _hoisted_4),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            ref: "btnNavLeft",
            id: _ctx.btnNavLeftId,
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.slideLeft())),
            class: "navLeft navButton",
            disabled: ""
          }, [
            (_openBlock(), _createElementBlock("svg", {
              width: _ctx.buttonSize,
              height: _ctx.buttonSize,
              viewBox: _ctx.buttonViewboxSize,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_10, 8, _hoisted_8))
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            id: _ctx.btnNavRightId,
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.slideRight())),
            class: "navButton"
          }, [
            (_openBlock(), _createElementBlock("svg", {
              width: _ctx.buttonSize,
              height: _ctx.buttonSize,
              viewBox: _ctx.buttonViewboxSize,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_14, 8, _hoisted_12))
          ], 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}